import React from 'react';
export function EditorTextItalicIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.02 3H19a1 1 0 110 2h-4.219l-3.5 14H15a1 1 0 110 2H5a1 1 0 110-2h4.22l3.5-14H9a1 1 0 010-2h4.978a.98.98 0 01.043 0z"
  }));
}